import { render } from "./AcademicsSidebar.vue?vue&type=template&id=611e3d8e"
import script from "./AcademicsSidebar.vue?vue&type=script&lang=js"
export * from "./AcademicsSidebar.vue?vue&type=script&lang=js"

import "@/assets/css/sidebar.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__